var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240.94 155.91",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.15,86.01c0,14.5-4.4,27.7-11.65,38.59h38.28c11.86,0,12.61-11.46,12.61-11.46v-27.13h-39.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.83,28.98c-12.43-11.05-28.73-17.43-45.22-17.43H16.25c-8.09,0-14.65,6.56-14.65,14.65v24.28h67.57c17.3,0,25.27,8.39,28.95,15.9,2.53-14.74,9.77-27.62,19.7-37.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.86,86.01h-38.59s-.76,27.51-32.1,27.51-67.57,0-67.57,0v24.28c0,8.09,6.56,14.65,14.65,14.65h56.36c34.01,0,67.25-27.08,67.25-66.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.33,77.99h38.59s.76-27.51,32.1-27.51h67.57v-24.28c0-8.09-6.56-14.65-14.65-14.65h-56.36c-34.01,0-67.25,27.08-67.25,66.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.cd773bf3c1f3dd60aaf1a6f914af70f8.svg";
export { ForwardRef as ReactComponent };